import React from 'react';
import EventLabelingChart from './EventLabellingChart';
import {
  SENTIMENT_VALUE_TO_PASS_TO_BACKEND_WHEN_CLICKING_SENTIMENT_TREND_CHART,
} from '../../home/redux/constants';
import { parseAreaChartData } from './HighChartUtils';

class AreaChart extends React.Component {
  constructor(props) {
    super(props);
  }

  getSentiment(seriesName) {
    return [SENTIMENT_VALUE_TO_PASS_TO_BACKEND_WHEN_CLICKING_SENTIMENT_TREND_CHART[seriesName]];
  }

  render() {
    return (
      <EventLabelingChart
        {...this.props}
        parseChartData={parseAreaChartData}
        getSentiment={this.getSentiment}
      />
    )
  }
}

export default AreaChart;



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/AreaChart.js